export const LOADING_MODULECONFIG = "LOADING_MODULECONFIG";
export const GET_MODULECONFIG_LIST = "GET_MODULECONFIG_LIST";
